import {
  DataSources,
  Diligence,
  ImportedData,
  OtherData,
  OutcomeReasons,
  ReasonCodes,
  Tags,
  YourCustomer,
} from '../cards';
import { Col, Row } from '../common';

export const BusinessUpdatedOverview = () => (
  <Row>
    <Col>
      <YourCustomer header="Business Updates" />
      <ImportedData />
      <OtherData />
    </Col>
    <Col>
      <OutcomeReasons />
      <Tags />
      <ReasonCodes />
      <Diligence />
      <DataSources />
    </Col>
  </Row>
);
